module.exports = ".mat-form-field {\n  padding: 10px; }\n\n.input-280 {\n  width: 280px; }\n"